import { trackEvent } from '@fs/zion-analytics'

const SUGGESTION_TYPE_ORIGINAL_TEXT = 'INPUT_TEXT_OPTION'

/**
 *  Get the metrics we want to track in Adobe.
 *
 *  This method is expected to be called only when the user selects a new
 *  suggestion to reduce impact on performance.
 *
 *
 *  Reports include:
 *  - language, Geo Location
 *    (This comes for free in Analytics track event)
 *
 *  - Standardized Place Country
 *    (from selected standard, zero - if not available)
 *
 *  - The index of the selected place within the selection list
 *    ( zero if not a standard,  1 - first standard,  2, ... for higher distance)
 *
 *  - Relevancy score
 *    ( highest score that is recommended to user )
 */
function getMetrics({ suggestion, suggestions, inputText = '', lastInputText }) {
  const ZERO = 'zero'
  const isOriginalText = suggestion?.type === SUGGESTION_TYPE_ORIGINAL_TEXT
  const selectedIndex =
    !isOriginalText && suggestion && suggestions && suggestions.indexOf(suggestion) !== -1
      ? suggestions.indexOf(suggestion) + 1
      : ZERO
  const inputTextLength = inputText !== lastInputText ? Math.abs(inputText.length - lastInputText.length) : ZERO
  const suggestionStandard = suggestion?.standard || suggestions.find((s) => s.isStandard === true)?.standard
  const countryId = suggestionStandard?.countryId || ZERO
  const relevanceScore = suggestionStandard?.relevanceScore || ZERO
  const jurisdictionLevel = suggestionStandard?.jurisdictionChain?.length || ZERO

  return { selectedIndex, inputTextLength, countryId, relevanceScore, jurisdictionLevel }
}

export default function trackPlaceSuggestionSelected({ suggestion, suggestions, inputText, lastInputText = '' }) {
  const metrics = getMetrics({ suggestion, suggestions, inputText, lastInputText })
  trackEvent({ link_name: 'PlaceSuggest:Standard:Click', event_name: 'click_action', ...metrics })
}
